import { makeStyles, alpha } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  contentBody: {
    marginTop: theme.spacing(3.5),
  },
  uploadSection: {
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.4),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(3, 0, 5, 0),
  },
  desc: {
    fontSize: "18px",
    lineHeight: "16px",
    fontWeight: "bold",
    margin: theme.spacing(3, 0),
    color: theme.custom.color.mortar,
  },
  button: {
    width: "auto",
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
      width: "20px",
      height: "20px",
    },
  },
}));
